import { useCallback } from 'react';
import { z } from 'zod';
import { FormFieldsSchema } from '@ninja/utilities';
import { prepareFieldError } from '../../../members/members-form/helpers/add-field-error';
import { useHasEmiratesIdField } from '../fields';
import { DocumentsForm, MemberDocumentForm } from '../types';

export const useHasEmiratesIdFieldsStructure = () => {
	const hasEmiratesIdField = useHasEmiratesIdField();
	const getFieldsStructure = useCallback(
		(memberId: string): FormFieldsSchema<DocumentsForm> => [hasEmiratesIdField.getField(memberId)],
		[hasEmiratesIdField.getField]
	);

	const getValidationSchema = () =>
		z.object({
			hasEmiratesId: hasEmiratesIdField.getValidation(),
		});

	const validate = (
		memberDocumentFormValue: Pick<MemberDocumentForm, 'hasEmiratesId'> | undefined,
		addFieldError: ReturnType<typeof prepareFieldError>
	) => {
		hasEmiratesIdField.validate(memberDocumentFormValue?.hasEmiratesId, addFieldError);
	};

	return {
		getFieldsStructure,
		getValidationSchema,
		validate,
	};
};
